import { render, staticRenderFns } from "./RegiaoForm.vue?vue&type=template&id=1599fe70&"
import script from "./RegiaoForm.vue?vue&type=script&lang=js&"
export * from "./RegiaoForm.vue?vue&type=script&lang=js&"
import style0 from "./RegiaoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports